import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import ValidPayBill from "../components/paybill/shop/valid/valid";
import PrefactorPayBill from "../components/paybill/shop/prefactor/prefactor";
import FinalPayBill from "../components/paybill/shop/final/final";

export const payBillRoutes = [
	<Route
		key="paybill-valid"
		path={_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Bill}
		element={<ProtectedRoute role={Roles.Dealer_HotBill_Pay} element={ValidPayBill} />}
	/>,
	<Route
		key="paybill-prefactor"
		path={_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Prefactor}
		element={<ProtectedRoute role={Roles.Dealer_HotBill_Pay} element={PrefactorPayBill} />}
	/>,
	<Route
		key="paybill-final"
		path={_adr.Root + _adr.PayBill.Index + _adr.PayBill.Shop + _adr.PayBill.Final}
		element={<ProtectedRoute role={Roles.Dealer_HotBill_Pay} element={FinalPayBill} />}
	/>,
];
